<template>
	<div id="productOptions" :class="{'disabled': fetchingProduct}">
		<h2 class="visually-hidden">Product Options</h2>
		<tool-tip
			v-for="s in childSelectors"
			:key="s.selectorLabel"
			:scroll="s.showSelectionError"
			:show="s.showSelectionError"
			:text="toolTipText(s)"
			:position="toolTipPosition"
		>
			<child-selector :selector="s" />
		</tool-tip>
		<div class="size-chart" v-if="product.sizeChartUrl">
			<a target="_blank" :href="product.sizeChartUrl">View Size Chart</a>
		</div>
		<product-stock-info @add-to-cart="$emit('add-to-cart')" />
	</div>
</template>

<script>
import ChildSelector from './ChildSelector.vue';
import ProductStockInfo from './ProductStockInfo.vue';
import ToolTip from '../../components/ToolTip.vue';

export default {
	name: 'ProductOptions',
	components: {
		ChildSelector,
		ToolTip,
		ProductStockInfo
	},
	computed: {
		childSelectors() {
			return this.$store.state.childSelectors;
		},
		fetchingProduct() {
			return this.$store.state.fetchingProduct;
		},
		product() {
			return this.$store.state.product;
		},
		remainingSelectors() {
			return this.$store.getters.remainingSelectors;
		},
		details() {
			return this.$store.state.details;
		},
		isGroupUrl() {
			return this.$store.state.isGroupUrl;
		},
		isMobile() {
			return this.$mq === 'pdp-mobile';
		},
		toolTipPosition() {
			return this.isMobile ? 'top' : 'left';
		},
		ctaStyles() {
			return this.childSelectors.length > 0 || this.isMobile ? 'border-top: 1px solid #CCCCCC;' : 'border-top: none;';
		},
		storeName() {
			return this.isSelectedForShipping ? 'online' :
				this.localStore ? `at ${this.localStore.cityAlias}` : '';
		}
	},
	methods: {
		toolTipText(selector) {
			return 'Select an available ' + selector.selectorLabel.toLowerCase();
		}
	},
	mounted() {

		// this should be an async function that awaits the call to selectProductAttributes
		// with a flat call to initDefaultFulfillment at the end, but IE blows up so this is how it has to be
		// for now (unless we configure babel correctly)

		if (this.details.isGroup && !this.isGroupUrl && this.childSelectors.length > 0) {
			return this.$store.dispatch('selectProductAttributes', this.product.blainNumber)
				.then(() => this.$store.dispatch('initDefaultFulfillment'));
		} else {
		 	return this.$store.dispatch('initDefaultFulfillment');
		}
	}
};
</script>

<style lang="less" scoped>
	@import '../../../less/_mixins.less';

	#productOptions {
		&.disabled {
			opacity: 0.8;
			pointer-events: none;
		}

		.grey-bg {
			background-color: tint(@CL, 90%);
			padding: 10px;
			border-bottom: 1px solid #CCCCCC;
		}
	}

	.size-chart {
		background-color: #EDEDED;
		border-radius: 6px;
		font-size: 14px;
		margin: 10px 0;
		text-align: center;
		padding: 8px;
		a {
			color: @blue-main;
		}
	}
</style>